
export function fetchSelectables(baseUrl, params) {
  let url = baseUrl;
  if (params) {
    url = url + "?" + $.param(params)
  }

  return fetch(url)
    .then((response) => response.json())
}